module.exports = __webpack_public_path__ + "img/21.27a274a1.png";